import api from '@/store/helpers/api';

let retries = 0;

async function wait(ms) {
  return new Promise((resolve) => {
    retries += 1;
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

const initialState = {
  loading: false,
  league: '',
  list: {
    gold: [],
    silver: [],
    bronze: [],
  },
  globalRank: 0,
  rank: 0,
  points: 0,
};

const getters = {
  rank(state) {
    return state.rank || 0;
  },
};

const actions = {
  async get({ commit, dispatch }) {
    commit('LOADSTART');
    if (!api.defaults.headers.common.Authorization && retries < 5) {
      await wait(300);
      return dispatch('get');
    }

    retries = 0;
    return api.get('/leaderboard')
      .then((data) => {
        commit('SET_RANK', data);
        commit('SET_LEAGUE', data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          setTimeout(() => {
            dispatch('get');
          }, 500);
        }
      })
      .finally(() => {
        commit('LOADEND');
      });
  },
  async getLeague({ commit, dispatch }, league) {
    if (typeof league === 'undefined') {
      return false;
    }

    commit('LOADSTART');
    if (!api.defaults.headers.common.Authorization && retries < 5) {
      await wait(300);
      return dispatch('getLeague', league);
    }

    retries = 0;
    return api.get(`/leaderboard/${league}`)
      .then((data) => {
        commit('SET_LEAGUE', data);
      })
      .finally(() => {
        commit('LOADEND');
      });
  },
};

const mutations = {
  LOADSTART(state) {
    state.loading = true;
  },
  LOADEND(state) {
    state.loading = false;
  },
  SET_RANK(state, data) {
    state.globalRank = data.globalRank;
    state.rank = data.rank;
    state.league = data.league;
  },
  SET_LEAGUE(state, data) {
    state.list[data.league] = data.leaderboard;
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
